/* SkinVibe „Jak założyć?” (snippets/sv-howto.liquid) - okno z filmem na karcie produktu.
   - otwiera je modal-opener motywu (global.js); tu: animacja zamknięcia 1:1 z oknem rat (sv-bnpl.js),
     start filmu po otwarciu (bez dźwięku; przy „ogranicz ruch” bez autostartu), zatrzymanie po zamknięciu
     (okno motywu ma wyłączone pauseAllMedia)
   - pomiar: sv_howto_view (przycisk widoczny) / open / play / progress 50 / complete / close
     -> GA4 (gtag z kolejką) i dataLayer tylko przy zgodzie analitycznej (K3 03.10, jak assets/sv-events.js),
        Shopify.analytics.publish zawsze */
(function () {
  'use strict';
  if (window.__svhLoaded) return;
  window.__svhLoaded = true;

  var GA4_ID = '';
  /* zgoda (03.10, K3; wzorzec assets/sv-events.js): dataLayer i GA4 tylko przy zgodzie analitycznej z Shopify Customer
     Privacy API. Zdarzenie sprzed decyzji w banerze czeka w kolejce (max ok. 10 min) i idzie po „Akceptuj” (1 s po zgodzie,
     żeby Consentmo zdążył zaktualizować tryb zgody gtag); „Odrzuć” albo brak decyzji przez 10 min = kolejka wyczyszczona.
     Wcześniej: GA4 po DOWOLNEJ decyzji (także po „Odrzuć”, wtedy hity bez cookies), dataLayer zawsze. K4 (04.10): zgoda sprzed wejścia na stronę (baner nie czekał w tej wizycie) = bez czekania 1 s (wzór sv-quiz). */
  var ga4Ready = false, gaQueue = [], gaPoll = null, gaTries = 0, consentYesAt = 0, consentWaited = false;
  function consentState() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return 'na';
    try {
      if (cp.analyticsProcessingAllowed()) return 'yes';
      var c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      return c && c.analytics === 'no' ? 'no' : '';
    } catch (e) { return 'na'; }
  }
  function gaFlush() {
    var st = consentState();
    if (st === '') consentWaited = true;
    if (st === 'no') { gaQueue.length = 0; return true; }
    if (st !== 'yes') return false;
    if (consentWaited) {
      if (!consentYesAt) consentYesAt = Date.now();
      if (Date.now() - consentYesAt < 1000) return false;
    }
    for (var i = 0; i < gaQueue.length; i++) {
      if (gaQueue[i].dl) continue;
      gaQueue[i].dl = true;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: gaQueue[i].name }, gaQueue[i].data));
      } catch (e) {}
    }
    if (!GA4_ID) { gaQueue.length = 0; return true; }
    if (typeof window.gtag !== 'function') return false;
    if (!ga4Ready) { window.gtag('config', GA4_ID, { send_page_view: false }); ga4Ready = true; }
    while (gaQueue.length) {
      var q = gaQueue.shift();
      try { window.gtag('event', q.name, Object.assign({ send_to: GA4_ID }, q.data)); } catch (e) {}
    }
    return true;
  }
  function gaSend(name, data) {
    gaQueue.push({ name: name, data: data, dl: false });
    if (gaFlush() || gaPoll) return;
    gaTries = 0;
    gaPoll = setInterval(function () {
      gaTries++;
      if (gaFlush() || gaTries > 2400) { clearInterval(gaPoll); gaPoll = null; gaQueue.length = 0; }
    }, 250);
  }
  /* perf 30.09 B-17 (wzorzec Shopify „yield to main thread”): analityka po narysowaniu klatki, żeby dotknięcie najpierw
     zmieniało ekran (lab 30.09 ×4: jeden track() = 20–25 ms, do ~70 ms). Karta w tle = od razu. */
  function afterPaint(cb) {
    if (document.hidden || typeof requestAnimationFrame !== 'function') { cb(); return; }
    requestAnimationFrame(function () { setTimeout(cb, 0); });
  }
  function track(name, data) {
    afterPaint(function () { trackNow(name, data); });
  }
  function trackNow(name, data) {
    var payload = data || {};
    try { gaSend(name, payload); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('skinvibe_' + name.replace(/^sv_/, ''), payload);
      }
    } catch (e) {}
  }

  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* zamknięcie z animacją - kopia animatedClose z sv-bnpl.js (klasa svh-modal--closing) */
  var CLOSING = 'svh-modal--closing';
  function animatedClose(modal) {
    if (modal._svhWrapped || typeof modal.hide !== 'function') return;
    modal._svhWrapped = true;
    var origHide = modal.hide.bind(modal);
    var inner = modal.querySelector('.svh-modal__inner');
    var x = modal.querySelector('[id^="ModalClose-"]');
    if (x) {
      x.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        modal.hide();
      }, true);
    }
    modal.hide = function () {
      if (modal.classList.contains(CLOSING)) return;
      if (!modal.hasAttribute('open') || !inner) { origHide(); return; }
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        inner.removeEventListener('animationend', onEnd);
        modal.classList.remove(CLOSING);
        origHide();
      };
      var onEnd = function (e) { if (e.target === inner) finish(); };
      inner.addEventListener('animationend', onEnd);
      modal.classList.add(CLOSING);
      setTimeout(finish, 320);
    };
  }

  function Howto(modal) {
    var self = this;
    this.modal = modal;
    this.video = modal.querySelector('[data-svh-video]');
    this.played = false;
    this.half = false;
    this.done = false;
    this.maxT = 0;
    if (modal.dataset.svhGa4) GA4_ID = modal.dataset.svhGa4;

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('modal-dialog').then(function () { animatedClose(modal); });
    } else {
      animatedClose(modal);
    }

    new MutationObserver(function () {
      if (modal.hasAttribute('open')) self.onOpen();
      else self.onClose();
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    var v = this.video;
    if (v) {
      v.addEventListener('playing', function () {
        if (self.played) return;
        self.played = true;
        track('sv_howto_play', { reason: v.muted ? 'muted' : 'sound' });
      });
      v.addEventListener('timeupdate', function () {
        var d = v.duration || 0;
        if (!d || !isFinite(d)) return;
        if (v.currentTime > self.maxT) self.maxT = v.currentTime;
        if (v.currentTime > (self.openMax || 0)) self.openMax = v.currentTime;
        if (!self.half && self.maxT >= d / 2) { self.half = true; track('sv_howto_progress', { percent: 50 }); }
        /* film jest w pętli, więc „ended” nie przychodzi - koniec = dojście do ostatnich 0,6 s */
        if (!self.done && self.maxT >= d - 0.6) { self.done = true; track('sv_howto_complete', { seconds: Math.round(d) }); }
      });
      v.addEventListener('volumechange', function () {
        if (!v.muted && !self.unmuted) { self.unmuted = true; track('sv_howto_sound', {}); }
      });
    }
  }

  Howto.prototype.onOpen = function () {
    var v = this.video;
    this.openMax = 0;
    if (!v) return;
    if (!v.poster && v.dataset.poster) v.poster = v.dataset.poster;
    try { v.currentTime = 0; } catch (e) {}
    if (reduceMotion) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  };

  Howto.prototype.onClose = function () {
    var v = this.video;
    if (v) { try { v.pause(); } catch (e) {} }
    track('sv_howto_close', { watched: Math.round(this.openMax || 0) });
  };


  /* ---------- „Dobierz w 2 krokach” (snippets/sv-pony-fit.liquid) ----------
     Kafle = zwykłe radia. Wynik ustawia kolor i rozmiar w natywnym variant-selects motywu
     (oba radia zaznaczone, jedno zdarzenie change), więc cena, zdjęcia i koszyk idą ścieżką motywu. */
  function Fit(modal) {
    var self = this;
    this.modal = modal;
    try { this.variants = JSON.parse(modal.querySelector('[data-svf-variants]').textContent); } catch (e) { this.variants = []; }
    if (modal.dataset.svhGa4) GA4_ID = modal.dataset.svhGa4;
    this.img = modal.querySelector('[data-svf-img]');
    this.name = modal.querySelector('[data-svf-name]');
    this.apply = modal.querySelector('[data-svf-apply]');
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('modal-dialog').then(function () { animatedClose(modal); });
    } else {
      animatedClose(modal);
    }
    /* zmiana kafla nie wychodzi poza okno: skrypty motywu nasłuchują 'change' na całym dokumencie
       i brały kafle z okna za wybór wariantu (26.09) */
    modal.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      e.stopPropagation();
      self.update(true);
    });
    new MutationObserver(function () {
      if (modal.hasAttribute('open')) self.syncFromPage();
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    if (this.apply) this.apply.addEventListener('click', function () { self.choose(); });
    document.querySelectorAll('[data-svf-open]').forEach(function (b) {
      b.addEventListener('click', function () { track('sv_fit_open', {}); });
    });
    this.update(false);
  }
  /* kind: 'a' = pytanie 1 (rozmiar), 'b' = pytanie 2 (kolor) */
  Fit.prototype.pick = function (kind) {
    var el = this.modal.querySelector('input[name^="svf-' + kind + '-"]:checked');
    return el ? el.value : '';
  };
  Fit.prototype.find = function (color, size) {
    for (var i = 0; i < this.variants.length; i++) {
      var o = this.variants[i].o || [];
      if (o.indexOf(color) > -1 && o.indexOf(size) > -1) return this.variants[i];
    }
    return null;
  };
  Fit.prototype.update = function (byUser) {
    var color = this.pick('b');
    var size = this.pick('a');
    var v = this.find(color, size);
    if (!v) return;
    this.current = v;
    if (this.img && v.img) this.img.src = v.img;
    if (this.name) this.name.textContent = color + ' · ' + size;
    /* Pony w kółku na kaflach rozmiaru ma kolor wybrany w kroku 2 */
    var self = this;
    [['Standard', '.svf-pony-s'], ['Large', '.svf-pony-l']].forEach(function (p) {
      var el = self.modal.querySelector(p[1]);
      var pv = self.find(color, p[0]);
      if (el && pv && pv.img && el.getAttribute('src') !== pv.img) {
        el.removeAttribute('srcset');
        el.removeAttribute('sizes');
        el.src = pv.img;
      }
    });
    if (this.apply) {
      this.apply.disabled = !v.a;
      this.apply.textContent = v.a ? 'Wybierz ten wariant' : 'Chwilowo niedostępny';
    }
    if (byUser) track('sv_fit_answer', { color: color, size: size });
  };
  /* przy otwarciu okna kafle pokazują to, co jest wybrane na stronie */
  Fit.prototype.syncFromPage = function () {
    var self = this;
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    vs.querySelectorAll('input[type="radio"]:checked').forEach(function (inp) {
      ['a', 'b'].forEach(function (kind) {
        self.modal.querySelectorAll('input[name^="svf-' + kind + '-"]').forEach(function (t) {
          if (t.value === inp.value) t.checked = true;
        });
      });
    });
    this.update(false);
  };
  Fit.prototype.choose = function () {
    var v = this.current;
    if (!v || !v.a) return;
    var vs = document.querySelector('variant-selects');
    var last = null;
    if (vs) {
      [this.pick('b'), this.pick('a')].forEach(function (val) {
        var inp = null;
        vs.querySelectorAll('input[type="radio"]').forEach(function (i) { if (i.value === val) inp = i; });
        if (inp && !inp.checked) { inp.checked = true; last = inp; }
      });
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    }
    track('sv_fit_select', { color: this.pick('b'), size: this.pick('a'), changed: !!last });
    if (this.modal.hide) this.modal.hide();
  };

  function bindPills() {
    document.querySelectorAll('[data-svh-open]').forEach(function (btn) {
      if (btn._svh) return;
      btn._svh = true;
      /* klik w trakcie animacji zamykania (0,24 s) ignorujemy - inaczej okno otwiera się i od razu gaśnie */
      btn.addEventListener('click', function (e) {
        var m = document.getElementById(btn.getAttribute('data-svh-open'));
        if (m && m.classList.contains(CLOSING)) { e.stopImmediatePropagation(); e.preventDefault(); return; }
        /* K4 (09.10): ui_from zamiast source - GA4 brał własny parametr source za źródło ruchu sesji (BigQuery: 427 sesji „gallery”) */
        track('sv_howto_open', { ui_from: 'gallery' });
      }, true);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries, obs) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        track('sv_howto_view', {});
      }, { threshold: 0.6 });
      io.observe(btn);
    });
  }

  function init() {
    document.querySelectorAll('modal-dialog.svh-modal').forEach(function (m) {
      if (m._svh) return;
      m._svh = m.hasAttribute('data-svf') ? new Fit(m) : new Howto(m);
    });
    bindPills();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
